import React, { useReducer, createContext } from "react";
import Cookies from 'js-cookie'

export const DemandContext = createContext();

const initialState = {
    Row: "",
    // AddressBookId: "",
    Population: "",
    LocationId: Cookies.get('locationId'),
    Areas: [],
    PropertyTypes: [],
    UsageTypes: [],
    MinSpace: "",
    MaxSpace: "",
    MinInfrastructure: "",
    MaxInfrastructure: "",
    MinSalePrice: "",
    MaxSalePrice: "",
    MinLoanPrice: "",
    MaxLoanPrice: "",
    MinMortgagePrice: "",
    MaxMortgagePrice: "",
    MinRentPrice: "",
    MaxRentPrice: "",
    ShortTermRent: "",
    CertificateType: [],
    Dongs: [],
    Aggregation: [],
    RentPrefer: [],
    MinPresalePrice: "",
    MaxPresalePrice: "",
    MinPrepayValue: "",
    MaxPrepayValue: "",
    MaxDeliveryDate: "",
    RequestSale: "",
    RequestRent: "",
    RequestPreSale: "",
    RequestExchange: "",
    RequestAssociate: "",
    EstateStatus: [],
    Water: "",
    Electricity: "",
    Gas: "",
    Phone: "",
    Direction: "",
    PropertyAge: [],
    MinRoomsCount: [],
    MinStreetSpace: "",
    Elevator: "0",
    Parking: "0",
    Store: "0",
    RegisterDate: "",
    PeriodInDays: "",
    ComeInSearchResult: "",
    Description: "",
    AgencyId: Cookies.get('agency') && JSON.parse(Cookies.get('agency')).Id,
    RegistrarUser: "",
    MustHaveLoan: "",//
    Priority1: "",//
    Priority2: "",//
    Priority3: "",//
    Priority4: "",//
    OwnerShouldNotResident: "", //
    IsNotImpasse: "0",
    Yard: "",
    Elec3Phase: "0",
    InputSeparate: "0", //
    MustHaveCommercial: "",//
    ReservedField: "", //
    ApplicantCanceled: "", //
    DoneTransact: "", //
    Tags: [],//
    Facilities: [],
    Tell: "", //
    Mobile: "",
    FullName: "",
    CommercialMeter: "0",
    Court: "0",
    floors: [],
    IsConfirmed: "1",
    RegistrarUser : "Site"
}

const reducer = (state, action) => {
    switch (action.type) {
        case "ADD_PICTURES":

            return {
                ...state,
                Pictures: [...state.Pictures, action.payload[1]]
            };
        case "UPDATE_STATE":
            console.log('action.payload.name', action.payload.name)
            // console.log('action.payload.value',action.payload.value)
            if (state[action.payload.name] != null) {
                var typeOfVar = typeof state[action.payload.name]

                console.log(typeOfVar)

                if (typeOfVar == "object") {
                    const isArray = Array.isArray(state[action.payload.name])
                    if (isArray) {
                        console.log("action.payload.value", action.payload.value)
                        if (!action.payload.append) {
                            if (state[action.payload.name].includes(action.payload.value)) {
                                const index = state[action.payload.name].indexOf(action.payload.value);
                                const newItem = state[action.payload.name].filter((item, index) => item != action.payload.value);
                                console.log(newItem)
                                return {
                                    ...state, [action.payload.name]: newItem
                                }
                            } else {
                                return {
                                    ...state, [action.payload.name]: [...state[action.payload.name], action.payload.value]
                                }
                            }
                        } else {
                            return {
                                ...state, [action.payload.name]: [...state[action.payload.name], action.payload.value]
                            }
                        }
                    }
                }
                else {
                    return {
                        ...state, [action.payload.name]: action.payload.value
                    };
                };
            } else {
                return {
                    ...state, [action.payload.name]: action.payload.value
                };
            }


        case "REMOVE_FROM_STATE":
            return {
                ...state, [action.payload.name]: [...state[action.payload.name], action.payload.value]
            };
        case "CLEAR_ITEM":
            return {
                ...state, [action.payload.name]: []
            };
        case "SET_ALL_ITEMS":
            return action.payload.newState;
        default:
            throw new Error();
    }
};

const DemandContextProvider = props => {
    const [state, dispatch] = useReducer(reducer, initialState);

    return (
        <DemandContext.Provider value={[state, dispatch]}>
            {props.children}
        </DemandContext.Provider>
    );
};
export default DemandContextProvider